module.exports = __webpack_public_path__ + "img/teddy-bear.383bab2f.svg";